import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { IEmptyMessage } from "@multiweb/types/react";
import { Icon, IconSize } from "../Icon";

export type EmptyMessageComponentProps = {
    /** Obsahuje lokalizovanou zprávu a kód ikony. */
    emptyMessage?: IEmptyMessage;
};

const classNames = bemClassNames("empty-message");

export const EmptyMessageComponent: FunctionComponent<EmptyMessageComponentProps> = ({ emptyMessage }) => (
    <div className={classNames()}>
        {emptyMessage ? <Icon iconCode={emptyMessage.iconCode} size={IconSize.large} /> : null}
        <div className={classNames("message")}>{emptyMessage?.text}</div>
    </div>
);
